export default {"src":"/_next/static/media/dumbell.6beda658.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};